import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormFlex, FormFlexItem } from '../../components/FormGrid';
import { styled } from '../../utils';
const BoardHeaderStyled = styled(FormFlex)(({ theme }) => ({
    paddingBottom: theme.spacing(2),
}));
const SubtitleStyled = styled(FormFlexItem)(() => ({
    display: 'flex',
    alignItems: 'center',
}));
export function Board({ title, subtitle, actions, content }) {
    return (_jsxs("div", { children: [_jsxs(BoardHeaderStyled, { rowGap: 2, columnGap: 2, justifyContent: "space-between", children: [_jsx(FormFlexItem, { width: "auto", children: title }), _jsx(SubtitleStyled, { width: "auto", height: "100%", children: subtitle }), _jsx(FormFlexItem, { width: "100%", children: actions })] }), content] }));
}
